import * as React from 'react';
import { isDev } from '../Util';
import { getSvgIconId } from '../Util/getSvgIconId';
import type { IconProps } from './Icon.types';

/**
 * This component renders a SVG icon with the given name.
 * All SVG icons should either be labeled as aria-hhidden:true or must have a aria-label if they are not hidden.
 */
export const Icon: React.FC<IconProps> = ({ className = '', ariaLabel = '', isAriaHidden = true, symbol }) => {
    if (isDev() && !isAriaHidden && !ariaLabel) {
        throw new Error('Icons that are aria-hidden set to false must have aria-label.');
    }

    const extraAttributes: React.SVGAttributes<SVGElement> = {};
    if (ariaLabel) {
        extraAttributes['aria-label'] = ariaLabel;
        extraAttributes.role = 'img';
    }
    const symbolIdentifier = getSvgIconId(symbol);

    return symbolIdentifier ? (
        <svg
            className={'svg-icon ' + className}
            aria-hidden={isAriaHidden}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...extraAttributes}
        >
            <use xlinkHref={symbolIdentifier} href={symbolIdentifier} />
        </svg>
    ) : null;
};
